import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

import PrivacyModeContent from 'ui-component/PrivacyModeContent';

import { useQuery } from 'react-query';
import agreementImage from 'assets/images/agreement.svg';
import StatusBadge from 'ui-component/StatusBadge';

import SalesOrderDetailInvoice from 'views/SalesOrders/SalesOrderDetailInvoice';
import InvoiceComponent from 'views/SalesOrders/components/InvoiceComponent';
import QoutationComponent from 'views/SalesOrders/components/QoutationComponent';

import ClientTimeline from 'ui-component/ClientTimeline';
import { Skeleton } from '@mui/material';
import useIsMobile from 'utils/isMobileUtils';


import usePageTitle from 'hooks/usePageTitle';

// ✅ Clear
const SalesOrderDetails = () => {
    const { id } = useParams();

    const [setPageTitle] = usePageTitle('Sales Order'); 

    const [selectedSalesOrder, setSelectedSalesOrder] = useState();
    

    const currentDate = moment().format('YYYY-MM-DD');

    const statusAllowedToPayAndSalesOrder = ['Draft', 'Canceled', 'Closed'];


    // End Create
    const history = useNavigate();
    const [modalPrice, setModalprice] = useState('00');

    const [shippingRow, setShippingrow] = useState({
        quantity: 1,
        unitPrice: 0,
        totalPrice: 0
    });

    const [selectedCustomerinfo, setSelectedCustomerInfo] = useState({});
    const [subTotal, setSubtotal] = useState('00');
    const [orderAgreementsData, setOrderAgreementsData] = useState([]);
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    

    const { data: requestData } = useQuery(
        ['salesorder-details', id, location],
        () => {
            const queryParams = new URLSearchParams(location.search);
            // const callbackParam = queryParams.get('callback-action-accept-order');
            // setRefreshKey(refreshKey + 1);
            return api.getClientSalesOrderDetails(id);
        },
        {
            // keepPreviousData: true,
            // initialData: (e) => {
                
            // 	const item = getLocalStorageCacheItem(md5(`salesorder-details-${id}-${refValue}`));
            // 	return item ? item : undefined;
            // },
            // onSuccess: (e) => {
            // 	setLocalStorageCacheItem(md5(`salesorder-details-${id}-${refValue}`), e, moment().add(3, 'days').format('YYYY-MM-DD'));
            // },
            // staleTime: 24 * 60 * 60 * 1000, 
        },
    );


    const [salesOrderRow, setSalesOrderRow] = useState({
        customer_id: '',
        sales_order_number: '',
        sales_manager: '',
        transit_id: '',
        vatStatus: 'Including VAT',
        vatPrice: 21,
        startDate: currentDate,
        expiresIn: 7,
        currency: 'eur',
        notes: []
    });
    // Row Area
    const [rows, setRows] = useState([{ id: 1, modelId: '', type: '', quantity: 0, unitPrice: 0, total: 0 }]);
    const options = {
        fields: ['address_components', 'geometry', 'icon', 'name'],
        types: ['establishment']
    };


    useEffect(() => {
        setSalesOrderRow((oldData) => ({ ...oldData, sales_manager: selectedCustomerinfo?.sales_manager_id }));
    }, [selectedCustomerinfo]);

    useEffect(() => {
        initiateDatas();
    }, [location]);


    useEffect(() => {
        if (requestData?.data?.data) {
            setSelectedSalesOrder(requestData?.data?.data);

            setOrderAgreementsData(requestData?.data?.data.order_agreements);
        }
    }, [requestData]);

    const initiateDatas = () => {
        if (id) {
        } else {
            history(`/sales/sales-orders`);
        }
    };

    useEffect(() => {
        if (selectedSalesOrder) {
            const expDate = moment(selectedSalesOrder?.expires_at).format('YYYY-MM-DD');
            let tempRow = selectedSalesOrder?.sales_order_items?.map((item, index) => {
                return {
                    id: index,
                    modelId: item?.product_id,
                    type: item?.product?.product_name,
                    quantity: item?.qty,
                    unitPrice: Number(item?.unit_price),
                    total: item?.total_price
                };
            });

            tempRow = [
                ...tempRow,
                {
                    id: tempRow.length + 1,
                    modelId: '',
                    type: '',
                    quantity: '',
                    unitPrice: '',
                    total: ''
                }
            ];

            setRows(tempRow);
            setSelectedCustomerInfo(selectedSalesOrder.customer);
            setSubtotal(selectedSalesOrder?.subtotal);

            const tempSalesOrder = {
                sales_order_number: selectedSalesOrder?.sales_order_number,
                customer_id: selectedSalesOrder?.customer_id,
                startDate: selectedSalesOrder?.start_at,
                expiryDate: expDate,
                transit_id: selectedSalesOrder?.transit_company?.id,
                sales_manager: selectedSalesOrder?.sales_person?.id,
                private_note: selectedSalesOrder?.private_note,
                vatStatus: selectedSalesOrder?.vat_type,
                vatPrice: selectedSalesOrder?.vat_percent || 21,
                currency: selectedSalesOrder?.currency,
                private_note: selectedSalesOrder?.private_note,
                expiresIn: moment(selectedSalesOrder?.expires_at).diff(selectedSalesOrder?.start_at, 'days')
            };

            let notesArray = [];

            selectedSalesOrder?.notes?.forEach((note) => {
                notesArray = [
                    {
                        id: note?.id,
                        details: note?.details,
                        date: moment(note?.created_at).format('YYYY-MM-DD'),
                        time: moment(note?.created_at).format('HH:mm'),
                        user_name: `${note?.user_created?.first_name} ${note?.user_created?.last_name}`,
                        expand: false,
                        isDeletable: note?.is_deletable
                    },
                    ...notesArray
                ];
            });

            notesArray = _.sortBy(notesArray, (n) => -n.id);

            const tempShipping = {
                unitPrice: selectedSalesOrder?.shipping_fee,
                quantity: selectedSalesOrder?.shipping_qty,
                totalPrice: Number(selectedSalesOrder?.shipping_fee) * Number(selectedSalesOrder?.shipping_qty)
            };
            setSalesOrderRow({ ...tempSalesOrder, notes: notesArray });
        }
    }, [selectedSalesOrder]);

    const calculateTotal = () => {
        let total = 0;
        let grandTotal = 0;
        for (let i = 0; i < rows.length; i++) {
            const { quantity, unitPrice } = rows[i];
            total += parseFloat(quantity || 0) * parseFloat(unitPrice || 0);
        }

        if (shippingRow?.totalPrice > 0) {
            const shippingTotal = parseFloat(shippingRow.totalPrice);
            grandTotal = total + shippingTotal;
        } else {
            grandTotal = total;
        }

        if (isNaN(grandTotal)) {
            return { subtotal: '00', modelTotal: '00' };
        }
        return { subtotal: grandTotal, modelTotal: total };
    };

    useEffect(() => {
        let tempsubtotal = calculateTotal();
        const subTotals = parseFloat(tempsubtotal?.subtotal).toFixed(2);
        const modaltotal = parseFloat(tempsubtotal?.modelTotal).toFixed(2);
        setSubtotal(subTotals);
        setModalprice(modaltotal);
    }, [rows, shippingRow, salesOrderRow]);

    useEffect(() => {
        if (salesOrderRow?.vatStatus == 'Excluding VAT' && salesOrderRow?.vatPrice > 0) {
            let tempvat = (modalPrice * (salesOrderRow?.vatPrice / 100)).toFixed(2);
            let temTotal = (parseFloat(subTotal) + parseFloat(tempvat)).toFixed(2);
        }
    }, [subTotal, modalPrice, salesOrderRow]);

    const isMobile = useIsMobile();

    return (
        <div className="row m-0 w-100 est-nv-container sales-container">
            <div className="col-12 col-md-8 offset-md-2 p-0 p-md-2 inv-preview">
                <div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
                    <div className="client-header-bubble" />
                    <div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
                        <div
                            style={{
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: 8,
                                minHeight: 38 // ensures enough height for the button
                            }}
                        >
                            {' '}
                            <button
                                type="button"
                                aria-label="Back"
                                onClick={() => history(-1)}
                                className="circle-back-btn"
                                style={{
                                    position: 'absolute',
                                    left: 20,
                                    top: '50%',
                                    transform: 'translateY(-50%)'
                                }}
                            >
                                {/* Replace with your fi arrow icon, example below */}
                                <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                                    <path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10}}>
                                <h5 style={{ textAlign: 'center', flex: 1, margin: 0, whiteSpace: 'nowrap' }}>Sales Order {selectedSalesOrder?.sales_order_number}</h5>
                                <StatusBadge itemStatus={selectedSalesOrder?.master_status?.name} />
                            </div>
                        </div>
                        <div
                            className={`${
                                selectedSalesOrder?.master_status?.name === 'Draft' || selectedSalesOrder?.master_status?.name === 'Paid'
                                    ? 'centered-buttons'
                                    : !statusAllowedToPayAndSalesOrder.includes(selectedSalesOrder?.master_status?.name)
                                    ? 'horizontal-scroll'
                                    : 'centered-buttons'
                            }`}
                            style={{ paddingLeft: 20, paddingRight: 20 }}
                        >
                        </div>
                    </div>
                </div>

                <div className="section-head-new pl-0 mb-1 mt-2 hide-on-mobile">
                    <div className="actions" style={{ gap: '5px', width: 'auto' }}>
                    </div>
                    <div className="actions" style={{ gap: '5px' }}>

                        <div className="est-detail-item">
                            {!selectedSalesOrder ? (
                                <div style={{ marginTop: '-6px', marginBottom: '9px' }}>
                                    <Skeleton variant="rounded" width={'100%'} height={40} />
                                </div>
                            ) : (
                                <StatusBadge itemStatus={selectedSalesOrder?.is_draft == 1 ? 'Draft' : selectedSalesOrder?.master_status?.name} />
                            )}
                        </div>
                    </div>
                </div>
                <div className="row hide-on-mobile">
                    <div className="col-12">
                        {!selectedSalesOrder ? (
                            <div style={{ width: '100%', marginBottom: '8px' }}>
                                <Skeleton variant="rounded" width={'100%'} height={160} style={{ borderRadius: '12px' }} />
                            </div>
                        ) : (
                            selectedSalesOrder?.master_status?.name !== 'Draft' && (
                                <div>
                                    <ClientTimeline
                                        id={selectedSalesOrder?.id}
                                        source={'sales_order'}
                                    />
                                </div>
                            )	
                        )}
                    </div>
                </div>
                <div className="row m-0 mobile-scroll-container">
                    <div className="show-on-mobile" style={{ width: '100%', display: 'flex' }}>
                        {!selectedSalesOrder ? (
                            <div style={{ width: '100%', marginBottom: '8px' }}>
                                <Skeleton variant="rounded" width={'100%'} height={36}></Skeleton>
                            </div>
                        ) : (
                            <div style={{ width: '100%', marginBottom: '8px', paddingTop: 10 }}>
                                <ClientTimeline
                                    // key={refreshKey}
                                    id={selectedSalesOrder?.id}
                                    source={'sales_order'}
                                />
                            </div>
                        )}
                    </div>
                    <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                        <SalesOrderDetailInvoice salesOrder={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} viewedBy={`CLIENT`} />
                        {!isMobile && (
                            <>
                                <div style={{ height: '0px' }}></div>

                                {selectedSalesOrder?.qoutation?.estimation_number && (
                                    <QoutationComponent details={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} />
                                )}
                                {selectedSalesOrder?.invoice?.invoice_number && (
                                    <InvoiceComponent details={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} viewedBy={`CLIENT`} />
                                )}
                            </>
                        )}
                    </div>
                    {isMobile && (
                        <>
                            <div style={{ height: '0px' }}></div>

                            {selectedSalesOrder?.qoutation?.estimation_number && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <QoutationComponent details={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} />
                                </div>
                            )}
                            {selectedSalesOrder?.invoice?.invoice_number && (
                                <div className="mb-3 p-3 p-xl-4 w-100 new-card">
                                    <InvoiceComponent details={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} viewedBy={`CLIENT`} />
                                </div>
                            )}
                        </>
                    )}
                    {orderAgreementsData?.length > 0 && (
                        <div className="card shadow-sm rounded bg-white mb-3 p-3 p-xl-4 w-100">
                            <div className="row">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="text-center mb-3 pt-2">
                                                <img src={agreementImage} alt="" height="70px" className="agreement-img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h4 className="text-center mb-3">SALES AGREEMENT</h4>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10 offset-md-1">
                                            <p className="text-center mb-3">
                                                This agreement is made on <Link to="#">{moment(selectedSalesOrder?.invoiceDate).format('DD MMMM YYYY')}</Link>{' '}
                                                between{' '}
                                                <Link to={`/contacts/${selectedSalesOrder?.customer?.id}`} target="_blank">
                                                    <PrivacyModeContent>{selectedSalesOrder?.customer?.name}</PrivacyModeContent>
                                                </Link>
                                                ,{' '}
                                                {selectedSalesOrder?.customer?.address && (
                                                    <>
                                                        located at{' '}
                                                        <Link to="#">
                                                            <PrivacyModeContent>
                                                                {selectedSalesOrder?.customer?.address ? `${selectedSalesOrder?.customer?.address}, ` : ''}
                                                                {selectedSalesOrder?.customer?.zipcode ? `${selectedSalesOrder?.customer?.zipcode}, ` : ''}
                                                                {selectedSalesOrder?.customer?.city ? `${selectedSalesOrder?.customer?.city}, ` : ''}
                                                                {selectedSalesOrder?.customer?.country ? `${selectedSalesOrder?.customer?.country}` : ''}
                                                            </PrivacyModeContent>
                                                        </Link>{' '}
                                                        (The Client){' '}
                                                    </>
                                                )}
                                                and{' '}
                                                {selectedSalesOrder?.transit_company?.name && (
                                                    <>
                                                        <Link to={`/contacts/${selectedSalesOrder?.transit_company?.id}`} target="_blank">
                                                            {selectedSalesOrder?.transit_company?.name}
                                                        </Link>{' '}
                                                        {selectedSalesOrder?.transit_company?.address && (
                                                            <>
                                                                located at{' '}
                                                                <Link to="#">
                                                                    {selectedSalesOrder?.transit_company?.address
                                                                        ? `${selectedSalesOrder?.transit_company?.address}, `
                                                                        : ''}
                                                                    {selectedSalesOrder?.transit_company?.zipcode
                                                                        ? `${selectedSalesOrder?.transit_company?.zipcode}, `
                                                                        : ''}
                                                                    {selectedSalesOrder?.transit_company?.city ? `${selectedSalesOrder?.transit_company?.city}, ` : ''}
                                                                    {selectedSalesOrder?.transit_company?.country
                                                                        ? `${selectedSalesOrder?.transit_company?.country}`
                                                                        : ''}
                                                                </Link>{' '}
                                                            </>
                                                        )}
                                                        (The Supplier).
                                                    </>
                                                )}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-10 offset-md-1">
                                            <p className="text-center mb-3">
                                                Both parties confirm that they have mutually agreed upon the following conditions, as negotiated between{' '}
                                                <b>
                                                    {selectedSalesOrder?.sales_person?.first_name} {selectedSalesOrder?.sales_person?.last_name}
                                                </b>
                                                , {selectedSalesOrder?.transit_company?.name && <> representing {selectedSalesOrder?.transit_company?.name}</>},{' '}
                                                and{' '}
                                                {selectedSalesOrder?.customer?.contact_name ? (
                                                    <>
                                                        <Link to={`contact/${selectedSalesOrder?.customer?.id}`} target="_blank">
                                                            <PrivacyModeContent>{selectedSalesOrder?.customer?.name}</PrivacyModeContent>
                                                        </Link>
                                                        , the representative of{' '}
                                                    </>
                                                ) : (
                                                    ''
                                                )}{' '}
                                                the representative of{' '}
                                                <Link to={`/contacts/${selectedSalesOrder?.customer?.id}`} target="_blank">
                                                    <PrivacyModeContent>{selectedSalesOrder?.customer?.name}</PrivacyModeContent>
                                                </Link>
                                                .
                                            </p>
                                        </div>
                                    </div>

                                    <div className="order-agreements-detail-section">
                                        {selectedSalesOrder?.order_agreements?.length > 0 && (
                                            <>
                                                {selectedSalesOrder?.order_agreements?.map((ag) => (
                                                    <div className="order-agreements-detail">
                                                        <h6>{ag?.title}</h6>
                                                        {ag?.type == 'multiselect' ? (
                                                            ag?.responses?.map((res) => <p>{res?.option?.option}</p>)
                                                        ) : (
                                                            <p>{ag?.response?.label}</p>
                                                        )}
                                                    </div>
                                                ))}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <p
                                                            className="d-flex justify-content-center align-items-center text-center mb-4 pt-4"
                                                            style={{ gap: '10px', color: '#838383', fontStyle: 'italic' }}
                                                        >
                                                            Note: <br />
                                                            Please be aware that a 2% charge will be applied to the entire order amount if payment is not made on
                                                            time,
                                                            <br />
                                                            due to fluctuations in USD and EUR currency values.
                                                        </p>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SalesOrderDetails;
